<template>
  <div class="h-full w-full flex flex-col">
    <div class="h-full container mx-auto">
      <div class="px-8 flex flex-col h-full w-full py-8">
        <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
          <div class="flex items-center text-sm font-light">
            <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
            <span class="mx-2">/</span>
            <router-link to="/employment" class="opacity-50 hover:opacity-100">Employment</router-link>
            <span class="mx-2">/</span>
            <span>Employers</span>
          </div>
          <div class="font-bold">Employers</div>
        </div>

        <!-- Employer Dashboard Start -->
        <div class="flex flex-col mt-8">
          <div class="grid grid-col-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-8">
            <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <div class="flex justify-between items-center">
                <div class="flex-grow flex flex-col">
                  <p class="text-xl">Total</p>
                  <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                  <h1 v-else class="text-3xl font-bold mt-1">
                    {{
                      !$apollo.queries.partners.loading && paginatorInfo
                        ? paginatorInfo.total
                        : 0
                    }}
                  </h1>
                </div>
              </div>
            </div>
            <div v-if="isShowChart('ATHS')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <div class="flex justify-between items-center">
                <div class="flex-grow flex flex-col">
                  <p class="text-xl">ATS</p>
                  <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                  <h1 v-else class="text-3xl font-bold mt-1">{{ atsTotal }}</h1>
                </div>
                <div class="flex-shrink-0">
                  <img class="h-8" src="../../assets/images/dashboard/alumni/ATS.png" alt="ATS" />
                </div>
              </div>
            </div>
            <div v-if="isShowChart('ADPOLY')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <div class="flex justify-between items-center">
                <div class="flex-grow flex flex-col">
                  <p class="text-xl">ADPOLY</p>
                  <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                  <h1 v-else class="text-3xl font-bold mt-1">
                    {{ adpolyTotal }}
                  </h1>
                </div>
                <div class="flex-shrink-0">
                  <img class="h-12" src="../../assets/images/dashboard/alumni/ADPOLY.png" alt="ADPOLY" />
                </div>
              </div>
            </div>
            <div v-if="isShowChart('FCHS')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <div class="flex justify-between items-center">
                <div class="flex-grow flex flex-col">
                  <p class="text-xl">FCHS</p>
                  <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                  <h1 v-else class="text-3xl font-bold mt-1">
                    {{ fchsTotal }}
                  </h1>
                </div>
                <div class="flex-shrink-0">
                  <img class="h-14" src="../../assets/images/dashboard/alumni/FCHS.png" alt="FCHS" />
                </div>
              </div>
            </div>
            <div v-if="isShowChart('ADVETI')" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <div class="flex justify-between items-center">
                <div class="flex-grow flex flex-col">
                  <p class="text-xl">ADVETI</p>
                  <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                  <h1 v-else class="text-3xl font-bold mt-1">
                    {{ advetiTotal }}
                  </h1>
                </div>
                <div class="flex-shrink-0">
                  <img class="h-16" src="../../assets/images/dashboard/alumni/ADVETI.png" alt="ADVETI" />
                </div>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">
            <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
              <h1 class="text-base md:text-lg font-semibold">Statistics</h1>
              <div class="flex flex-row flex-wrap">
                <div class="w-full sm:w-1/2 flex flex-col text-base md:text-lg pt-4">
                  <div class="flex justify-between sm:justify-start items-center flex-wrap">
                    <div class="w-52 lg:w-32 xl:w-52 2xl:w-64">
                      Total Employers
                    </div>
                    <div class="flex items-center">
                      <span class="hidden sm:block mr-0 sm:mr-2">:</span><span class="font-bold">{{
                        !$apollo.queries.partners.loading && paginatorInfo
                          ? paginatorInfo.total
                          : 0
                      }}</span>
                    </div>
                  </div>
                  <div class="flex justify-between sm:justify-start items-center flex-wrap mt-2">
                    <div class="w-52 lg:w-32 xl:w-52 2xl:w-64">Approved</div>
                    <div class="flex items-center">
                      <span class="hidden sm:block mr-0 sm:mr-2">:</span><span class="font-bold">{{
                        partnerReport ? partnerReport.approved_count : 0
                        }}</span>
                    </div>
                  </div>
                  <div class="flex justify-between sm:justify-start items-center flex-wrap mt-2">
                    <div class="w-52 lg:w-32 xl:w-52 2xl:w-64">
                      Not Verified
                    </div>
                    <div class="flex items-center">
                      <span class="hidden sm:block mr-0 sm:mr-2">:</span><span class="font-bold">{{
                        partnerReport ? partnerReport.not_verified_yet_count : 0
                        }}</span>
                    </div>
                  </div>
                  <div class="flex justify-between sm:justify-start items-center flex-wrap mt-2">
                    <div class="w-52 lg:w-32 xl:w-52 2xl:w-64">Rejected</div>
                    <div class="flex items-center">
                      <span class="hidden sm:block mr-0 sm:mr-2">:</span><span class="font-bold">{{
                        partnerReport ? partnerReport.rejected_count : 0
                        }}</span>
                    </div>
                  </div>
                </div>
                <div class="w-full sm:w-1/2 flex justify-center">
                  <apexchart type="donut" width="380" :options="chartOptions" :series="series"></apexchart>
                </div>
              </div>
            </div>
            <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
              <h1 class="text-lg font-bold">Employers / Entity</h1>
              <div v-if="isDashboardLoading" class="wd-380 ht-242-7 flex items-center">
                <div class="">
                  <div class="ml-8 wd-216 ht-216 rounded-full bg-gray-200 animate-pulse"></div>
                </div>
              </div>
              <apexchart v-else type="pie" width="380" :options="chartOptions1" :series="series1"></apexchart>
            </div>
          </div>
        </div>
        <!-- Employer Dashboard End -->

        <div v-if="hasPermission('partners-export-excel')" class="mt-4 flex justify-end items-center">
          <div v-if="isExportExcel"
            class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg hover:text-ternary text-white">
            <base-spinner-with-text class-list="w-4 h-4" text="" text-class-list="text-white"></base-spinner-with-text>
            <span class="text-xs">Exporting Excel</span>
          </div>
          <div v-else @click="generateReport"
            class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg cursor-pointer hover:text-ternary text-white">
            <font-awesome-icon :icon="['fas', 'file-excel']" />
            <span class="text-xs ml-2">Export Excel</span>
          </div>
        </div>

        <section :class="hasPermission('partners-export-excel') ? 'mt-4' : 'mt-8'"
          class="h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
          <div class="flex justify-between flex-wrap gap-4">
            <h1 class="text-base md:text-lg font-semibold">Employers List</h1>
            <div class="flex justify-start items-center flex-wrap gap-4">
              <div class="w-full sm:w-auto border rounded-lg px-4 h-8 flex items-center">
                <div class="text-sm mr-2">Entity:</div>
                <select v-model="filterByEntity" class="outline-none text-sm flex-grow">
                  <option value="">All</option>
                  <option :value="item.entity" v-for="(item, index) in filteredEntities" :key="index">{{
                    getEntityName(item.entity) }}</option>
                </select>
              </div>
              <div class="w-full sm:w-auto border rounded-lg px-4 h-8 flex items-center">
                <div class="text-sm mr-2">Sector:</div>
                <select v-model="filterBySector" class="outline-none text-sm flex-grow">
                  <option value="">All</option>
                  <option value="Government – Federal">Government – Federal</option>
                  <option value="Government – Local">Government – Local</option>
                  <option value="Semi-Government">Semi-Government</option>
                  <option value="Private">Private</option>
                </select>
              </div>
              <div class="w-full sm:w-auto">
                <search @on-search="onSearch" class-list="px-4 h-8"></search>
              </div>
            </div>
          </div>

          <div class="flex flex-col mt-4" v-if="$apollo.queries.partners.loading">
            <table-shimmer :titleHeaders="[
              '#',
              'Company Name',
              'Registered Date',
              'Company Location',
              'Entity Type',
              'Entity of interest',
              'Company Short Name',
              'Status',
              'Actions',
            ]" :rows="first"></table-shimmer>
          </div>
          <div v-else-if="!$apollo.queries.partners.loading && !hasItems"
            class="h-full flex justify-center items-center">
            <h1 class="text-center text-xl font-medium">No employers found!</h1>
          </div>
          <div v-else class="flex flex-col mt-4">
            <div class="flex flex-col overflow-x-auto">
              <div class="inline-block min-w-full py-2">
                <div class="overflow-x-auto">
                  <table class="min-w-full text-left text-sm font-light">
                    <thead class="border-b font-medium dark:border-neutral-500">
                      <tr>
                        <th scope="col" class="px-6 py-2 text-gray-400 w-8">
                          #
                        </th>
                        <th scope="col" class="px-6 py-2 text-gray-400">
                          Company Name
                        </th>
                        <th scope="col" class="px-6 py-2 text-gray-400">
                          Registered Date
                        </th>
                        <th scope="col" class="px-6 py-2 text-gray-400">
                          Company Location
                        </th>
                        <th scope="col" class="px-6 py-2 text-gray-400">
                          Entity Type
                        </th>
                        <th scope="col" class="px-6 py-2 text-gray-400">
                          Entity of interest
                        </th>
                        <th scope="col" class="px-6 py-2 text-gray-400">
                          Company Short Name
                        </th>
                        <th scope="col" class="px-6 py-2 text-gray-400">
                          Status
                        </th>
                        <th scope="col" class="px-6 py-2 text-gray-400">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in filteredPartners" :key="index"
                        class="border-b border-dashed dark:border-neutral-500">
                        <td class="whitespace-nowrap px-6 py-2 font-medium">
                          {{ paginatorInfo.firstItem + index }}
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">
                          <div @click.stop="openModal(item, 'Employer Details')"
                            class="flex items-center cursor-pointer group">
                            <div class="flex-shrink-0 mr-3">
                              <img class="h-12 w-12 rounded-lg object-contain cursor-pointer"
                                :src="getImage(item.company_logo)" alt="" />
                            </div>
                            <div class="flex-grow flex flex-col mr-4">
                              <h1 class="text-sm font-semibold flex items-center">
                                <span class="text-heading group-hover:text-blue-600 group-hover:underline">{{
                                  item.en_company_name }}</span>
                                <span v-if="item.user.is_approved"
                                  class="ml-1 h-3 w-3 rounded-full bg-blue-600 flex items-center justify-center">
                                  <icon-check class="w-2 h-2 text-white"></icon-check>
                                </span>
                              </h1>
                              <p class="text-xs text-gray-400">
                                {{ item.ar_company_name }}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">
                          {{ getRegisteredDate(item.created_at) }}
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">
                          {{ item.city }}
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">
                          {{ item.entity_industry }}
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">
                          {{ getEntityName(item.entity) }}
                        </td>
                        <td class="whitespace-nowrap px-6 py-2">
                          {{ item.company_short_name }}
                        </td>
                        <td class="whitespace-nowrap px-6 py-2" v-html="getStatus(
                          item.user.is_approved,
                          item.partners_approvals
                        )
                          "></td>
                        <td class="px-6 py-2">
                          <div class="flex">
                            <div v-if="
                              hasPermission('partners-edit') &&
                              isShowApproveReject(item.user.is_approved)
                            " @click.stop="reviewAndVerify(item)"
                              class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                              <icon-approve
                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-approve>
                            </div>
                            <div v-if="
                              hasPermission('partners-edit') &&
                              isShowApproveReject(item.user.is_approved)
                            " @click.stop="rejectClicked(item.user.id)"
                              class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                              <icon-reject
                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-reject>
                            </div>
                            <div @click.stop="openModal(item, 'Employer Details')"
                              class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                              <icon-eye
                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                            </div>
                            <div v-if="hasSuperPermission('partners-delete')" @click.stop="deleteEmployer(index)"
                              class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer">
                              <icon-trash
                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-trash>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
            </div>
          </div>

          <transition name="fade" mode="out-in">
            <base-modal v-if="showAddNote" :title="`Add Your Note`" @close="closeAddNote">
              <div class="flex flex-col">
                <label for="note" class="px-8 mt-4 text-sm ml-1">Note</label>
                <div class="h-32 px-8 rounded-xl mt-2">
                  <textarea v-model="note"
                    class="bg-white resize-none w-full h-full outline-none text-sm border p-4 rounded-lg"></textarea>
                </div>
                <div class="flex justify-end mt-4 mr-8">
                  <div @click.stop="addNoteOk"
                    class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                    OK
                  </div>
                </div>
              </div>
            </base-modal>
          </transition>

          <transition name="fade" mode="out-in">
            <base-full-modal v-if="isOpenModal" :title="modalTitle" height="" @close="closeModal">
              <partner-view :item="selectedItem" :title="modalTitle" @verify-me="onVerifyMe"
                @update-employer-details="onUpdateEmployerDetails" @close="closeModal"></partner-view>
            </base-full-modal>
          </transition>

        </section>
      </div>
    </div>
    <div class="h-full flex justify-center items-center" v-if="isLoading || isExportExcel">
      <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
    </div>
  </div>
</template>

<script>
import IconEye from "../../components/icons/IconEye.vue";
import IconTrash from "../../components/icons/IconTrash.vue";
import gql from "graphql-tag";
import Pagination from "../../components/shared/pagination.vue";
import TableShimmer from "../../components/shared/TableShimmer.vue";
import IconApprove from "../../components/icons/IconApprove.vue";
import IconReject from "../../components/icons/IconReject.vue";
import IconCheck from "../../components/icons/IconCheck.vue";
import PartnerView from "./view.vue";
import { formattedDate } from "../../helpers/utils";
import Search from "../../components/shared/search.vue";
import xlsx from "xlsx/dist/xlsx.full.min.js";

const DELETE_EMPLOYER_MUTATION = gql`
    mutation DeleteEmployer($partner_id: Int!) {
        deleteEmployer(partner_id: $partner_id) {
            error
            message
        }
    }
`;

export default {
  name: "partners-index",
  components: {
    IconEye,
    IconTrash,
    Pagination,
    TableShimmer,
    IconApprove,
    IconReject,
    IconCheck,
    PartnerView,
    Search,
  },
  data() {
    return {
      partners: [],
      first: 10,
      page: 1,
      createModal: false,
      editModal: false,
      modalTitle: "",
      selectedItem: null,
      error: null,
      success: null,
      showAddNote: false,
      note: "",
      selectedUserId: null,
      isLoading: false,
      isOpenModal: false,
      partnerReport: null,
      entities: [],
      filterByEntity: "",
      filterBySector: "",
      chartOptions: {
        chart: {
          width: 380,
          type: "donut",
        },
        labels: ["Approved", "Not Verified", "Rejected"],
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        dataLabels: {
          enabled: true,
        },
        fill: {
          type: "gradient",
        },
        colors: ["#00e397", "#feb219", "#ff4561"],
        legend: {
          position: "bottom",
        },
      },
      isDashboardLoading: false,
      atsTotal: 0,
      adpolyTotal: 0,
      fchsTotal: 0,
      advetiTotal: 0,
      searchText: "",
      isExportExcel: false,
      isApiCallRecurisive: false,
      generatedReport: [],
    };
  },
  watch: {
    searchText() {
      this.page = 1;
    },
    partners(newVal) {
      if (newVal.error) {
        if (newVal.error_code == 403) {
          this.$router.replace("/no-permission");
        } else if (newVal.error_code == 401) {
          this.$router.replace("/");
        } else {
          alert(newVal.message);
          this.$router.replace("/");
        }
      }
    },
    filterByEntity() {
      this.filterBySector = "";
      this.page = 1;
      this.getPartnerReport();
    },
    filterBySector() {
      this.page = 1;
      this.getPartnerReport();
    },
  },
  computed: {
    filteredPartners() {
      return this.partners.data;
    },
    hasItems() {
      if (this.filteredPartners && this.filteredPartners.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    paginatorInfo() {
      return this.partners.paginatorInfo;
    },
    role() {
      return this.$store.getters.role;
    },
    filteredEntities() {
      return this.entities.data;
    },
    series() {
      let approvedCount = 0;
      let rejectedCount = 0;
      let notVerifiedYetCount = 0;

      if (this.partnerReport) {
        approvedCount = this.partnerReport.approved_count;
        rejectedCount = this.partnerReport.rejected_count;
        notVerifiedYetCount = this.partnerReport.not_verified_yet_count;
      }

      return [approvedCount, notVerifiedYetCount, rejectedCount];
    },
    series1() {
      switch (this.filterByEntity) {
        case "ATHS":
          return [this.atsTotal];
        case "ATS":
          return [this.atsTotal];
        case "ADPOLY":
          return [this.adpolyTotal];
        case "FCHS":
          return [this.fchsTotal];
        case "ADVETI":
          return [this.advetiTotal];
        default:
          return [
            this.atsTotal,
            this.adpolyTotal,
            this.fchsTotal,
            this.advetiTotal,
          ];
      }
    },
    chartOptions1() {
      const labels = this.getLabelBasedOnEntity();
      return {
        chart: {
          width: 380,
          type: "pie",
        },
        labels: labels,
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
    userEntities() {
      return this.$store.getters.entity;
    },
  },
  created() {
    this.getPartnerReport();
  },
  apollo: {
    partners() {
      return {
        query: gql`
          query GetAllPartners(
            $first: Int!
            $page: Int!
            $entity: String
            $entity_industry: String
            $search: String
          ) {
            partners(
              first: $first
              page: $page
              entity: $entity
              entity_industry: $entity_industry
              search: $search
            ) {
              error
              error_code
              message
              data {
                id
                entity_industry
                en_company_name
                ar_company_name
                company_short_name
                company_logo
                mother_company_name
                company_size
                trade_license_number
                trade_license_authority
                company_type
                other_company_type
                economic_activity
                city
                website
                company_logo
                entity
                commercial_activity
                first_name
                last_name
                mobile_number
                land_line_number
                email
                username
                designation
                avatar
                chart_file
                trading_license_file
                user {
                  id
                  is_approved
                  email_verification_token
                }
                created_at
                partners_approvals {
                  user {
                    name
                    email
                  }
                }
                contact_persons {
                  token
                  first_name
                  last_name
                  mobile_number
                  land_line_number
                  email
                  username
                  designation
                  avatar
                  is_owner
                  user {
                    is_approved
                    email_verification_token
                  }
                }
              }
              paginatorInfo {
                count
                currentPage
                firstItem
                hasMorePages
                lastItem
                lastPage
                perPage
                total
              }
            }
          }
        `,
        variables() {
          return {
            first: this.first,
            page: this.page,
            entity: this.filterByEntity,
            entity_industry: this.filterBySector,
            search: this.searchText,
          };
        },
        fetchPolicy: "cache-and-network",
      };
    },
    entities() {
      return {
        query: gql`
          query GetEntityList {
            entities {
              data {
                entity
              }
            }
          }
        `,
        fetchPolicy: "cache-and-network",
      };
    },
  },
  methods: {
    onSearch(searchText) {
      this.searchText = searchText;
    },
    closeAddNote() {
      this.showAddNote = false;
      this.note = "";
      this.selectedUserId = null;
    },
    addNoteOk() {
      this.showAddNote = false;
      this.updateApplication(this.selectedUserId, false);
    },
    reviewAndVerify(item) {
      this.openModal(item, 'Review & Verify Employer Details');
    },
    onVerifyMe(selectedUserId) {
      this.updateApplication(selectedUserId, true);
      this.closeModal();
    },
    async onUpdateEmployerDetails() {
      await this.$apollo.queries.partners.refetch();
      // Find the updated item in filteredPartners and update selectedItem
      const updatedItem = this.filteredPartners.find(item => item.id === this.selectedItem.id);
      if (updatedItem) {
        this.selectedItem = { ...updatedItem }; // Create a new object to trigger reactivity
      }
    },
    isShowApproveReject(status) {
      if (status === null) {
        return true;
      } else {
        return false;
      }
    },
    getStatus(status, partnersApproval) {
      if (status === null) {
        return `<div class="flex flex-col items-center"><div class="text-yellow-600">Not verified yet</div></div>`;
      } else if (status === false) {
        if (partnersApproval) {
          return `<div class="flex flex-col items-center"><div class="text-red-600">Rejected by</div><div>${partnersApproval.user.name}</div><div>(${partnersApproval.user.email})</div></div>`;
        } else {
          return `<div class="flex flex-col items-center"><div class="text-red-600">Rejected</div></div>`;
        }
      } else {
        if (partnersApproval) {
          return `<div class="flex flex-col items-center"><div class="text-green-600">Approved by</div><div>${partnersApproval.user.name}</div><div>(${partnersApproval.user.email})</div></div>`;
        } else {
          return `<div class="flex flex-col items-center"><div class="text-green-600">Approved</div></div>`;
        }
      }
    },
    rejectClicked(selectedUserId) {
      this.selectedUserId = selectedUserId;
      this.showAddNote = true;
    },
    async updateApplication(user_id, status) {
      this.isLoading = true;

      const UPDATE_PARTNER_APPLICATION_MUTATION = gql`
        mutation UpdatePartnerApplication(
          $user_id: String!
          $status: Boolean!
          $note: String
        ) {
          updatePartnerApplication(
            user_id: $user_id
            status: $status
            note: $note
          ) {
            error
            message
          }
        }
      `;

      try {
        await this.$apollo
          .mutate({
            mutation: UPDATE_PARTNER_APPLICATION_MUTATION,
            variables: {
              user_id: user_id,
              status: status,
              note: this.note,
            },
          })
          .then((data) => {
            if (data.data.updatePartnerApplication.error) {
              this.error = data.data.updatePartnerApplication.message;
            } else {
              this.success = data.data.updatePartnerApplication.message;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } catch (error) {
        this.error = error.message || "Failed to authenticate, try later.";
      }

      if (this.error === null) {
        this.isLoading = false;

        this.note = "";

        this.$apollo.queries.partners.refetch();

        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        if (status) {
          Toast.fire({
            icon: "success",
            title: "Application approved!",
          });
        } else {
          Toast.fire({
            icon: "success",
            title: "Application rejected!",
          });
        }
      }
    },
    getImage(url) {
      return process.env.VUE_APP_PUBLIC_URL + url;
    },
    setPage(page) {
      this.page = page;
    },
    openModal(item, title) {
      this.modalTitle = title;
      this.selectedItem = item;
      this.isOpenModal = true;
    },
    closeModal() {
      this.isOpenModal = false;
      this.selectedItem = null;

      this.createModal = false;
      this.editModal = false;
      this.modalTitle = "";
    },
    showToast(message = "") {
      this.$apollo.queries.partners.refetch();
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: message,
      });
      this.closeModal();
    },
    onRoleCreated() {
      this.showToast("Role Created Successfully");
    },
    editRole(item) {
      this.selectedItem = item;
      this.editModal = true;
    },
    onRoleUpdated() {
      this.showToast("Role Updated Successfully");
    },
    hasPermission(crudName) {
      if (this.role == "superadmin") {
        return true;
      } else {
        const permissions = this.$store.getters.permissions;
        const permissionsArray = permissions.split(",");
        if (permissionsArray.includes(crudName)) {
          return true;
        } else {
          return false;
        }
      }
    },
    hasSuperPermission(crudName) {
      const permissions = this.$store.getters.permissions;
      const permissionsArray = permissions.split(",");
      if (permissionsArray.includes(crudName)) {
        return true;
      } else {
        return false;
      }
    },
    getRegisteredDate(date) {
      return formattedDate(date);
    },
    async getPartnerReport() {
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query GetPartnerReport($entity: String, $entity_industry: String) {
              partnerReport(
                entity: $entity
                entity_industry: $entity_industry
              ) {
                data {
                  not_verified_yet_count
                  approved_count
                  rejected_count
                  ats_total
                  fchs_total
                  adpoly_total
                  adveti_total
                }
              }
            }
          `,
          variables: {
            entity: this.filterByEntity,
            entity_industry: this.filterBySector,
          },
          fetchPolicy: "network-only",
        });
        this.partnerReport = data.partnerReport.data;
        this.atsTotal = this.partnerReport.ats_total;
        this.fchsTotal = this.partnerReport.fchs_total;
        this.adpolyTotal = this.partnerReport.adpoly_total;
        this.advetiTotal = this.partnerReport.adveti_total;
      } catch (error) {
        console.log(error);
      }
    },
    getLabelBasedOnEntity() {
      switch (this.filterByEntity) {
        case "ATHS":
          return ["ATS"];
        case "ATS":
          return ["ATS"];
        case "ADPOLY":
          return ["ADPOLY"];
        case "FCHS":
          return ["FCHS"];
        case "ADVETI":
          return ["ADVETI"];
        default:
          return ["ATS", "ADPOLY", "FCHS", "ADVETI"];
      }
    },
    isShowChart(entity) {
      if (this.filterByEntity == "") {
        if (this.role == "superadmin" || this.userEntities === null) {
          return true;
        } else {
          const entitiesArray = this.userEntities.split(",");
          if (entitiesArray.includes(entity)) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return this.filterByEntity == entity;
      }
    },
    getEntityName(entity) {
      return entity.replace(/ATHS/g, "ATS");
    },
    async generateReport() {
      var page = 1;
      var limit = 200;
      this.isExportExcel = true;
      this.isApiCallRecurisive = true;
      while (this.isApiCallRecurisive) {
        const responseData = await this.fetchForExporting(page, limit);
        if (responseData.error) {
          this.$swal
            .fire({
              icon: "error",
              title: "Oops...",
              text: responseData.message,
            })
          break;
        }

        if (responseData.data.length > 0) {
          this.generatedReport.push(
            ...responseData.data.map((obj) => {
              return {
                name: `${obj.first_name} ${obj.last_name}`,
                designation: obj.designation,
                mobile_number: obj.mobile_number,
                land_line_number: obj.land_line_number,
                email: obj.email,
                en_company_name: obj.en_company_name,
                ar_company_name: obj.ar_company_name,
                company_short_name: obj.company_short_name,
                entity_industry: obj.entity_industry,
                entity: obj.entity,
                created_at: this.getRegisteredDate(obj.created_at),
              };
            })
          );
          page++;
        } else {
          this.isApiCallRecurisive = false;
          break;
        }
      }
      this.exportToExcel("Employers");
    },
    async fetchForExporting(pageNo = 1, limitSize = 50) {
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query ExportPartners(
              $page: Int
              $limit: Int
              $entity: String
              $entity_industry: String
              $search: String
            ) {
              exportPartners(
                page: $page
                limit: $limit
                entity: $entity
                entity_industry: $entity_industry
                search: $search
              ) {
                error
                error_code
                message
                data {
                  en_company_name
                  ar_company_name
                  company_short_name
                  entity_industry
                  mother_company_name
                  company_size
                  trade_license_number
                  trade_license_authority
                  company_type
                  other_company_type
                  economic_activity
                  city
                  website
                  entity
                  commercial_activity
                  first_name
                  last_name
                  mobile_number
                  land_line_number
                  email
                  designation
                  created_at
                }
              }
            }
          `,
          fetchPolicy: "network-only",
          variables: {
            page: pageNo,
            limit: limitSize,
            entity: this.filterByEntity,
            entity_industry: this.filterBySector,
            search: this.searchText,
          },
        });

        const responseData = data.exportPartners;
        return responseData;
      } catch (error) {
        console.log(error.message);
      }
    },
    exportToExcel(reportName) {
      const XLSX = xlsx;

      let header = [
        "NAME",
        "DESIGNATION",
        "MOBILE NUMBER",
        "LANDLINE NUMBER",
        "EMAIL",
        "COMPANY NAME (EN)",
        "COMPANY NAME (AR)",
        "COMPANY SHORT NAME",
        "SECTOR",
        "ENTITY",
        "REGISTERED AT",
      ];

      const worksheet = XLSX.utils.json_to_sheet(this.generatedReport);
      const columnWidths = [];

      for (let i = 0; i < header.length; i++) {
        const column = String.fromCharCode(65 + (i % 26));
        const row = Math.floor(i / 26);
        const columnLetter = row > 0 ? String.fromCharCode(64 + row) + column : column;
        worksheet[`${columnLetter}1`] = { v: header[i], t: "s" };
        columnWidths.push({ width: Math.max(40, header[i].length + 5) });
      }

      worksheet["!cols"] = columnWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `${reportName}.xlsx`);

      this.generatedReport = [];
      this.isExportExcel = false;
      this.isApiCallRecurisive = false;
    },
    async deleteEmployer(index) {
      if (index == null || index < 0 || index >= this.filteredPartners.length) return;

      const confirmed = await this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this! All job postings associated with this employer will be permanently deleted.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
      });

      if (!confirmed.isConfirmed) return;

      const partnerId = this.filteredPartners[index].id;

      this.isLoading = true;

      try {
        const { data } = await this.$apollo.mutate({
          mutation: DELETE_EMPLOYER_MUTATION,
          variables: {
            partner_id: parseInt(partnerId),
          },
        });

        if (data.deleteEmployer.error) {
          await this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: data.deleteEmployer.message,
          });
          return;
        }

        await this.$swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: data.deleteEmployer.message,
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
        });

      } catch (error) {
        await this.$swal.fire({
          icon: 'error',
          title: 'Failed!',
          text: error.message || 'Could not delete employer.',
        });
      } finally {
        this.isLoading = false;
        this.page == 1 ? this.$apollo.queries.partners.refetch() : this.page = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@responsive {
  .wd-380 {
    width: 380px;
  }

  .ht-242-7 {
    height: 242.7px;
  }

  .wd-216 {
    width: 216px;
  }

  .ht-216 {
    height: 216px;
  }
}
</style>
